import { RightOutlined } from "@ant-design/icons";
import { IBreadLink } from "@interfaces";
import { Breadcrumb } from "antd";
import { memo } from "react";
const style = { marginBottom: 39 };
interface IProps {
  pages?: IBreadLink[];
}
export const ComponentBread = memo(({ pages }: IProps) => (
  <Breadcrumb separator={<RightOutlined />} items={pages || []} style={style} />
));
